/**
 *
 * @author Matthew Rawson @ 22/02/2018 11:04
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {Overlay, Tooltip} from "react-bootstrap"

import id from "@irati/utils/id"
import {brand, greys} from "@irati/ui/src/global/colors"
import {Dosis} from "@irati/ui/src/global/fonts"

const Button = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${({isUpComing}) => (isUpComing ? greys.light : brand.default)};
  padding: 0;
  margin: 0;
  outline: 0;
  border: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`

const Circle = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${greys.white};
  margin: 0 auto;
`

const StyledTooltip = styled(Tooltip)`
  .tooltip-inner  {
    text-align: center;
    height: 40px;
    background-color: ${() => brand.default};
    border-radius: 3px;
    padding: 9px 15px;
    font-size: 21px;
    font-family: ${Dosis};
    color: ${greys.white};
  }
  .tooltip-arrow {
    border-top-color: ${() => brand.default} !important;
  }
`

class ProgressButton extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    isUpComing: PropTypes.bool,
    isActive: PropTypes.bool,
    children: PropTypes.node
  };
  static defaultProps = {
    onClick: () => (undefined),
    disabled: false,
    isUpComing: true,
    isActive: false,
    children: null
  };


  constructor(props) {
    super(props)
    this.state = {}
    this.button = React.createRef()
  }


  render() {
    const idNamespace = id("ProgressButton", this.props)
    const {onClick, isUpComing, disabled, isActive, children} = this.props

    return (
      <>
        <Overlay placement="top" show={children && isActive && !disabled} target={this.button.current}>
          <StyledTooltip id={idNamespace}>{this.props.children}</StyledTooltip>
        </Overlay>
        <Button
          id={idNamespace}
          onClick={onClick}
          isUpComing={isUpComing}
          disabled={disabled}
          ref={this.button}>

          {(isUpComing || isActive) && <Circle />}
        </Button>
      </>
    )
  }
}

export default ProgressButton
